import React, { useState, useEffect } from "react";
import styles from "./Prompts.module.css";
import Button from "../buttons/Button";
import FullscreenCard from "../containers/FullscreenCard";

const InfoPrompt = ({ text, statusCleared }) => {
  const [divClass, setDivClass] = useState(styles.statusDivInactive);

  useEffect(() => {
    setDivClass(text ? styles.statusDivActive : styles.statusDivInactive);
  }, [text]);

  const onClickHandler = (event) => {
    event.preventDefault();
    setDivClass(styles.statusDivInactive);
    statusCleared();
  };

  return (
    <>
      {text && (
        <FullscreenCard>
          <div className={divClass}>
            <p>{text}</p>
            <Button text={"OK"} disabled={false} onClick={onClickHandler} />
          </div>
        </FullscreenCard>
      )}
    </>
  );
};

export default InfoPrompt;
